@use '../../design-tokens/typography/typography' as *;
@use '../../design-tokens/border-radius/border-radius' as *;

@layer design-system {
  .root {
    display: inline-flex;
    align-items: center;
    box-sizing: content-box;
    @include typography-v2-ui-xs;

    &.sizeMedium {
      @include typography-v2-ui-sm;
    }
  }

  .numerical {
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--text-on-critical);
    background-color: var(--action-critical-default);
    border-radius: 20px;

    &.sizeMedium {
      height: 20px;
      min-width: 20px;
      padding: 2px 7px;
    }

    &.sizeSmall {
      height: 16px;
      min-width: 16px;
      padding: 0 5px;
    }
  }

  .textual {
    @include border-radius-r2;
    display: inline-flex;
    padding: 4px 8px;
    gap: 4px;
    align-items: center;
    box-sizing: border-box;



    &.sizeXsSmall {
      padding: 2px 8px;
    }
  }

  .solidNeutral {
    color: var(--text-default);
    background-color: var(--surface-neutral);

    svg {
      fill: var(--icon-default);
    }
  }

  .solidPrimary {
    color: var(--text-on-primary);
    background-color: var(--surface-primary);

    svg {
      fill: var(--icon-on-primary);
    }
  }

  .solidSuccess {
    color: var(--text-success);
    background-color: var(--surface-success);

    svg {
      fill: var(--icon-success);
    }
  }

  .solidWarning {
    color: var(--text-warning);
    background-color: var(--surface-warning);

    svg {
      fill: var(--icon-warning);
    }
  }

  .solidError {
    color: var(--text-critical);
    background-color: var(--surface-critical);

    svg {
      fill: var(--icon-critical);
    }
  }

  /* Outline */
  .outlineNeutral {
    color: var(--text-default);
    border: 1px solid var(--border-default);

    svg {
      fill: var(--icon-default);
    }
  }

  .outlinePrimary {
    color: var(--text-primary);
    border: 1px solid var(--border-primary);

    svg {
      fill: var(--icon-primary);
    }
  }

  .outlineSuccess {
    color: var(--text-success);
    border: 1px solid var(--border-success);

    svg {
      fill: var(--icon-success);
    }
  }

  .outlineWarning {
    color: var(--text-warning);
    border: 1px solid var(--border-warning);

    svg {
      fill: var(--icon-warning);
    }
  }

  .outlineError {
    color: var(--text-critical);
    border: 1px solid var(--border-critical);

    svg {
      fill: var(--icon-critical);
    }
  }
}